module.exports = __webpack_public_path__ + "static/media/newyork.502fdbfd.png";